<div class="sub-nav w-206px o-hidden" [ngClass]="{ 'nav-expanded': isNavExpanded }">
  <div class="section centered-vert justify-cont-sb pt-8px pr-4px pb-8px pl-18px">
    <h1 class="title fs-20px fw-700 ink-100-v2">{{ subSectionTitle }}</h1>
    <gh-toggle-nav action="collapse"></gh-toggle-nav>
  </div>
  <div id="sub-nav-container" [ngSwitch]="activeScreen">
    <gh-home-sub-navigation *ngSwitchCase="'home'" (titleChange)="onTitleChanged($event)"></gh-home-sub-navigation>
    <gh-sessions-sub-navigation *ngSwitchCase="'sessions'" (titleChange)="onTitleChanged($event)"></gh-sessions-sub-navigation>
    <gh-kpis-sub-navigation *ngSwitchCase="'kpis'" (titleChange)="onTitleChanged($event)"></gh-kpis-sub-navigation>
    <gh-tasks-sub-navigation *ngSwitchCase="'tasks'" (titleChange)="onTitleChanged($event)"></gh-tasks-sub-navigation>
    <gh-whiteboards-sub-navigation *ngSwitchCase="'whiteboards'" (titleChange)="onTitleChanged($event)"></gh-whiteboards-sub-navigation>
    <gh-settings-sub-navigation *ngSwitchCase="'settings'" (titleChange)="onTitleChanged($event)"></gh-settings-sub-navigation>
    <gh-reports-sub-navigation *ngSwitchCase="'reports'" (titleChange)="onTitleChanged($event)"></gh-reports-sub-navigation>
    <gh-people-sub-navigation *ngSwitchCase="'people'" (titleChange)="onTitleChanged($event)"></gh-people-sub-navigation>
    <gh-insightboards-sub-navigation *ngSwitchCase="'insightboards'" (titleChange)="onTitleChanged($event)"></gh-insightboards-sub-navigation>
  </div>
</div>
